import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Edit2 } from 'react-feather';

import styles from 'styles/Unit.module.scss';
import TextareaCounter from 'components/InputCounter/InputCounter';
import { Controller, useForm } from 'react-hook-form';
import ButtonAction from './ButtonAction';
import ButtonSubmit from './ButtonSubmit';
import useI18n from '../../../../../../../hooks/use-i18n';
import CustomEditorMCE from 'components/Editor/CustomEditorTinyMCE';
import { FormGroup } from 'reactstrap';
import { useUnit } from 'hooks/units';
import { COURSE_STATUS } from 'constants/constants';

const TextReply = ({
  type,
  setType,
  onSubmitCompleteUnit,
  setIntervalFunc,
}) => {
  const i18n = useI18n();
  const unitSelected = useUnit();
  //DisableConditon
  let isDisabled = unitSelected?.status == COURSE_STATUS.INACTIVE;

  const [isLoading, setIsLoading] = useState(false);
  const { register, watch, reset, control, errors, getValues } = useForm({
    defaultValues: { content: unitSelected?.content },
    mode: 'onChange',
    reValidateMode: 'onChange',
    shouldUnregister: false,
  });
  const content = watch('content');

  const handleSubmit = async () => {
    const elm = document.getElementById('sendReply');
    const content = elm.value;

    if (!content) return;
    setIsLoading(true);
    await onSubmitCompleteUnit({ content });
    setIsLoading(false);
  };

  const handleTableSubmit = async () => {
    const data = getValues();
    const content = data.content;

    if (!content) return;
    setIsLoading(true);
    await onSubmitCompleteUnit({ content });
    setIsLoading(false);
  };

  useEffect(() => {
    reset({
      sendReply: '',
    });
  }, [type]);
  return (
    <div>
      {type === 'text' && (
        <>
          {/* {(unitSelected?.tableStructure == false ||
            !unitSelected?.tableStructure) && (
            <TextareaCounter
              className={styles.inputTextarea}
              type="textarea"
              id="sendReply"
              name="sendReply"
              innerRef={register({
                required: i18n.t('message.errorRequired'),
              })}
              propsValue={sendReply}
              max={unitSelected?.maxTextCharactor ?? 1500}
              isUseForm
            />
          )} */}

          <FormGroup>
            <Controller
              control={control}
              name="content"
              defaultValue={
                unitSelected?.tableStructure ? unitSelected?.content : null
              }
              render={({ onChange, value, defaultValue }) => (
                <CustomEditorMCE
                  setEditorState={(value) => onChange(value)}
                  editorState={value || defaultValue}
                  height={400}
                />
              )}
            />
          </FormGroup>

          <div className={styles.footerAssigment}>
            <ButtonSubmit
              onClick={handleTableSubmit}
              title="Send your reply"
              onCancel={() => setType('')}
              disabled={!content || isLoading || isDisabled}
            />
          </div>
        </>
      )}
      {!type && (
        <ButtonAction
          disabled={isDisabled}
          icon={<Edit2 />}
          text="Text reply"
          onClick={() => {
            setType('text');
            setIntervalFunc();
          }}
        />
      )}
    </div>
  );
};

TextReply.propTypes = {
  type: PropTypes.string.isRequired,
  setType: PropTypes.func.isRequired,
  onSubmitCompleteUnit: PropTypes.func.isRequired,
};

export default TextReply;
